import { TreeView } from "@mui/x-tree-view/TreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import Card from "react-bootstrap/Card";
import Nav from "react-bootstrap/Nav";
import { Button, CardHeader, Form } from "react-bootstrap";
import { getTranslations } from "../../Shared/translations";
import "./buildingtree.css";
import * as myTreeIcons from "../../images/icons/treeicons";

import { kamerItem } from "../../Shared/sharedInterfaces";

import * as newTreeIcons from "../../images/icons/svgIcons";
import { ThemeProvider, createTheme } from "@mui/material";

import {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import React from "react";

// Utility to get saved state from localStorage
const getPersistedExpanded = (): string[] => {
  const stored = localStorage.getItem("expandedTreeNodes");
  return stored ? JSON.parse(stored) : [];
};

const addIfNotExists = (arr: string[], item: string): string[] => {
  return arr.includes(item) ? arr : [...arr, item];
};

// Utility to save to localStorage
const saveExpanded = (expanded: string[]) => {
  const sortedDesc = expanded.sort((a, b) => Number(b) - Number(a));
  localStorage.setItem("expandedTreeNodes", JSON.stringify(sortedDesc));
};

// Utility to save single id
const addExpanded = (expanded: string) => {
  const currExp = getPersistedExpanded();
  if (currExp) {
    const updatedExpanded = addIfNotExists(currExp, expanded);
    saveExpanded(updatedExpanded);
  }
};

// This is an array with the ids of all items
// Used to expand all items
const getTreeArray = (treeviewArrayFromOpbouw: kamerItem) => {
  let treeItemsArray: string[] = [];
  treeItemsArray = myTreeIcons.itemArray(treeviewArrayFromOpbouw);
  return treeItemsArray;
};

interface MyProps {
  treeviewArrayFromOpbouw: kamerItem;
  onWoningItemClick: (type: string, nodeId: string, label: string) => void;
  onNameChange: (itemId: string, newName: string) => void;
  onDuplicate: (itemId: string, newName: string) => void;
  onIconChange: (itemId: string, icon: string) => void;
  onRemoveItem: (itemId: kamerItem[]) => void;
  onMoveItem: (itemToMove: kamerItem[], newParent: kamerItem) => void;
}

export interface buildingTreeRefs {
  childFunction: (arr: kamerItem, foced: boolean) => void;
}

const BuildingTree = forwardRef<buildingTreeRefs, MyProps>(
  (
    {
      treeviewArrayFromOpbouw,
      onWoningItemClick,
      onNameChange,
      onDuplicate,
      onIconChange,
      onRemoveItem,
      onMoveItem,
    },
    ref,
  ) => {
    useImperativeHandle(ref, () => ({
      // This function is triggered after we open a project.
      // It sets all levels as expanded
      childFunction(arr: kamerItem, forced: boolean) {
        if (forced) {
          //console.log(arr);
          const expArr: string[] = getTreeArray(arr);
          //console.log(expArr);
          saveExpanded(expArr);
          setExpanded(expArr);
        }
      },
    }));

    const [, setLanguageVersion] = useState(0);

    useEffect(() => {
      const handler = () => setLanguageVersion((v) => v + 1);
      window.addEventListener("databasesReloaded", handler);
      return () => window.removeEventListener("databasesReloaded", handler);
    }, []);

    const t = getTranslations();

    const [context, setContext] = useState(false);
    const [changeName, setchangeName] = useState(false);
    const [duplicateRoom, setDuplicateRoom] = useState(false);
    const [changeIcon, setchangeIcon] = useState(false);
    const [selected, setSelected] = React.useState<kamerItem[]>([]);
    const [xyPosition, setxyPosition] = useState({ x: 0, y: 0 });
    const [selectedRoom, setSelectedRoom] = React.useState<kamerItem>();
    const [expanded, setExpanded] = useState<string[]>(() => {
      const stored = localStorage.getItem("expandedTreeNodes");
      return stored
        ? JSON.parse(stored)
        : getTreeArray(treeviewArrayFromOpbouw); // fallback to all expanded
    });
    const [draggedNode, setDraggedNode] = useState<kamerItem | null>(null);
    const [selNode, setSelNode] = useState<kamerItem>({
      id: "",
      name: "",
      key: "",
      icon: null,

      nodeid: "",
      label: "",
      type: "",
      parent: "",
      typeIcon: "",
      moduleType: "",
      children: [],
    });

    let currIcon: string = "";
    let nieweNaam = "";
    let duplicateRoomTemp = "";

    // Show the context menu
    function showMenu(event: any, nodes: kamerItem) {
      event.preventDefault();
      event.stopPropagation();

      setSelNode(nodes);

      setContext(false);
      setchangeName(false);
      setchangeIcon(false);
      setDuplicateRoom(false);

      const positionChangeA = {
        x: event.nativeEvent.offsetX,
        y: event.nativeEvent.offsetY,
      };

      const positionChange = {
        x: event.clientX - 75,
        y: event.clientY - 150,
      };

      //set menu position
      setxyPosition(positionChange);

      // show menu
      setContext(true);
    }

    // Hides the context menu
    const hideContext = (event: any) => {
      setContext(false);
    };

    // Update localStorage and state whenever expanded change
    useEffect(() => {
      saveExpanded(expanded);
      setExpanded(expanded);
    }, [expanded]);

    // Adds the room where is clicked on to expanded
    const handleToggle = (_event: React.SyntheticEvent, nodeIds: string[]) => {
      setExpanded(nodeIds);
    };

    // Sets the selected room as room to add stuff to
    function setItem(type: string, nodeId: string, label: string) {
      setContext(false);
      setchangeName(false);
      setchangeIcon(false);
      setDuplicateRoom(false);

      //we should be sure that we set the expanded
      addExpanded(nodeId);
      const lsexp = localStorage.getItem("expandedTreeNodes");
      if (lsexp) {
        setExpanded(JSON.parse(lsexp));
      }

      if (type === "woning") {
        onWoningItemClick(type, nodeId, label);
      }
    }

    // Gets triggered if user type's in a new name
    // Stores the value of textbox to a variable
    function onNaamChange(event: any) {
      nieweNaam = event.target.value;
    }

    // Saves the new name (on button press)
    function changeItemName(id: string) {
      setchangeName(false);
      setDuplicateRoom(false);
      onNameChange(id, nieweNaam);
    }

    // Saves the new name (on ENTER key)
    function onNaamKeyPress(event: any) {
      if (event.keyCode == 13) {
        changeItemName(selNode.id);
      }
    }

    function onDuplicateNaamChange(event: any) {
      duplicateRoomTemp = event.target.value;
    }

    function duplicateRoomF(id: string) {
      setDuplicateRoom(false);
      onDuplicate(id, duplicateRoomTemp); // your parent callback
    }

    function onDuplicateNaamKeyPress(event: any) {
      if (event.keyCode === 13) {
        duplicateRoomF(selNode.id);
      }
    }

    // Gets triggered from contect menu - Delete
    // Sends items back to parent (opbouw) to delete them from DB
    function removeItem() {
      setContext(false);
      // Check if any selected item has icon.key === "woning"
      const woningItemName = selected.find((item) => {
        const icon = item.icon;
        if (React.isValidElement(icon)) {
          return String(icon.key) === "woning";
        }
        return false;
      })?.name;

      if (woningItemName) {
        const confirmDelete = window.confirm(
          `Opgelet, uw selectie bevat een kamer: ${woningItemName}. Alle uitgangen in deze kamer zullen ook verwijderd worden.`,
        );
        if (!confirmDelete) {
          return;
        }
      }

      onRemoveItem(selected);
      setSelected([]);
    }

    // Gets triggered from contect menu - Change icon
    // Sends items back to parent (opbouw) to change icon in DB
    function changeItemIcon(id: string) {
      setchangeIcon(false);
      onIconChange(id, currIcon);
    }

    // Renders the component to change a name
    const renderChangeName = () => {
      nieweNaam = selNode.name;
      const nameDiv = () => (
        <div
          style={{
            top: xyPosition.y,
            left: xyPosition.x,
            position: "absolute",
          }}
          className="chane_name"
        >
          <Form.Control
            type="text"
            id="nieuwenaam"
            name="nieuwenaam"
            aria-describedby=""
            defaultValue={selNode.name}
            onChange={onNaamChange}
            onKeyDown={onNaamKeyPress}
          />

          <Button onClick={() => changeItemName(selNode.id)}>
            {" "}
            {t.wijzigNaam}
          </Button>
        </div>
      );

      return nameDiv();
    };

    // Renders the component to duplicate a room
    const renderDuplicateRoom = () => {
      duplicateRoomTemp = selNode.name;
      const duplicateDiv = () => (
        <div
          style={{
            top: xyPosition.y,
            left: xyPosition.x,
            position: "absolute",
          }}
          className="chane_name"
        >
          <Form.Control
            type="text"
            id="duplicatenaam"
            name="duplicatenaam"
            aria-describedby=""
            defaultValue={selNode.name}
            onChange={onDuplicateNaamChange}
            onKeyDown={onDuplicateNaamKeyPress}
          />

          <Button onClick={() => duplicateRoomF(selNode.id)}> {t.dupliceren}</Button>
        </div>
      );

      return duplicateDiv();
    };

    // Sets the new icon to variable
    // After change ok used in changeItemIcon
    function handleIconChange(eventKey: any) {
      switch (eventKey.target.id) {
        case "icon-fan":
          currIcon = "fan";
          break;
        case "icon-rel":
          currIcon = "relais";
          break;
        case "icon-handdoek":
          currIcon = "hand";
          break;
        case "icon-stopc":
          currIcon = "stopc";
          break;
        default:
          currIcon = "relais";
          break;
      }
    }

    // Renders the component to change the icon
    const renderChangeIcon = () => {
      currIcon = "relais";
      const iconDiv = () => (
        <div
          style={{
            top: xyPosition.y,
            left: xyPosition.x,
            position: "absolute",
          }}
          className="chane_icon"
        >
          {" "}
          <Form onChange={handleIconChange}>
            <Form.Check type="checkbox" id="icon-rel" className="iconCheck">
              <Form.Check.Input
                type="radio"
                name="full"
                defaultChecked={true}
              />
              <Form.Check.Label className="formLabel">
                <div style={{ height: "50px", width: "50px" }}>
                  <newTreeIcons.RelaisIcon />
                </div>
              </Form.Check.Label>
            </Form.Check>

            <Form.Check type="checkbox" id="icon-fan" className="iconCheck">
              <Form.Check.Input type="radio" name="full" />
              <Form.Check.Label className="formLabel">
                <div style={{ height: "50px", width: "50px" }}>
                  <newTreeIcons.FanIcon />
                </div>
              </Form.Check.Label>
            </Form.Check>

            <Form.Check
              type="checkbox"
              id="icon-handdoek"
              className="iconCheck"
            >
              <Form.Check.Input type="radio" name="full" />
              <Form.Check.Label className="formLabel">
                <div style={{ height: "50px", width: "50px" }}>
                  <newTreeIcons.HanddoekIcon />
                </div>
              </Form.Check.Label>
            </Form.Check>

            <Form.Check type="checkbox" id="icon-stopc" className="iconCheck">
              <Form.Check.Input type="radio" name="full" />
              <Form.Check.Label className="formLabel">
                <div style={{ height: "50px", width: "50px" }}>
                  <newTreeIcons.StopcontactkIcon />
                </div>
              </Form.Check.Label>
            </Form.Check>

            <Button onClick={() => changeItemIcon(selNode.id)}>
              {" "}
              {t.wijzigIcon}
            </Button>
          </Form>
        </div>
      );

      return iconDiv();
    };

    // Renders the Conetxt menu component
    const renderContext = () => {
      // Here we check if the selected output is of type REL
      // If so, we need to show the Change Icon menu
      let relNode = false;
      if (selNode.icon) {
        if (React.isValidElement(selNode.icon)) {
          switch (selNode.icon.key) {
            case "REL":
            case "hand":
            case "stopc":
            case "fan":
              relNode = true;
              break;
            default:
              break;
          }
        }
      }

      const menuDiv = () => (
        <div
          style={{
            top: xyPosition.y,
            left: xyPosition.x,
            position: "absolute",
          }}
          className="contextm"
          onClick={hideContext}
        >
          <div className="menuElement" onClick={() => removeItem()}>
            {t.verwijderen}
          </div>
          <div className="menuElement" onClick={() => setchangeName(true)}>
            {t.hernoem}
          </div>
          <div className="menuElement" onClick={() => setDuplicateRoom(true)}>
            {t.dupliceren}
          </div>
          {relNode ? (
            <div className="menuElement" onClick={() => setchangeIcon(true)}>
              {t.wijzigIcon}
            </div>
          ) : (
            <></>
          )}
        </div>
      );

      return menuDiv();
    };

    // Helper function for moveNode
    // Recursivly check child nodes
    const checkChildrenRecursively = (
      nodes: kamerItem[],
      target: kamerItem,
      items2move: any,
      onMoveItem: (items: any, target: kamerItem) => void,
    ) => {
      nodes?.forEach((child) => {
        // Match the ID
        if (child.id === target.id) {
          const icon = child.icon;

          // Check if icon is a valid React element and has key === 'woning'
          if (React.isValidElement(icon)) {
            const key = icon.key;
            console.log("Key:", key);

            if (key === "woning") {
              onMoveItem(items2move, target);
            }
          }
        }

        // Recurse into children
        if (child.children?.length) {
          checkChildrenRecursively(
            child.children,
            target,
            items2move,
            onMoveItem,
          );
        }
      });
    };

    // Helper: move dragged node under target node
    const moveNode = (dragged: kamerItem, target: kamerItem) => {
      // If we only move one item -> add it to items2move
      // else -> add selection to items2move
      let items2move: kamerItem[] = [];

      if (selected.length === 0) {
        items2move.push(dragged);
      } else {
        items2move = selected;
      }

      // Check type of target (we should only move to a type of woning)
      // Move all selected items to the target
      checkChildrenRecursively(
        [treeviewArrayFromOpbouw],
        target,
        items2move,
        onMoveItem, // Call function on parent to move items in database
      );
      setSelected([]);
    };

    // Handlers for drag & drop
    const onDragStart = (
      event: React.DragEvent<HTMLDivElement>,
      node: kamerItem,
    ) => {
      event.stopPropagation();
      event.dataTransfer.effectAllowed = "move";

      event.dataTransfer.setData("text/plain", node.id);
      setDraggedNode(node);
    };

    // Just a function to prevent standard dragover behavior
    const onDragOver = (event: React.DragEvent<HTMLDivElement>) => {
      event.preventDefault(); // must prevent default to allow drop
    };

    // Move node to this node
    const onDrop = (
      event: React.DragEvent<HTMLDivElement>,
      targetNode: kamerItem,
    ) => {
      event.preventDefault();
      event.stopPropagation();
      if (!draggedNode) return;
      if (draggedNode.id === targetNode.id) return; // no self drop
      // Move node or selected nodes to target
      moveNode(draggedNode, targetNode);
    };

    // On component mount, restore from localStorage
    // Still here in case we have to update code to set ietems after page refresh
    /*
    useEffect(() => {
      const savedSelected = localStorage.getItem('selectedIds');
      if (savedSelected) {
        debugger
        setSelected(JSON.parse(savedSelected));
      }

      const savedSelectedRoomId = localStorage.getItem('selectedRoomId');
      if (savedSelectedRoomId) {
        // find the kamerItem with this id and setSelectedRoom
        const room = findRoomById(savedSelectedRoomId, treeviewArrayFromOpbouw);
        if (room) {
          setSelectedRoom(room);
        }
      }
      
    }, []);
*/
    // Handles multi select/ room select/ output seletc
    const handleToggleSelect = (node: kamerItem, event: any) => {
      const isMultiSelect = event.ctrlKey || event.metaKey;

      setSelected((prevSelected) => {
        let newSelected;

        if (isMultiSelect) {
          if (prevSelected.includes(node)) {
            newSelected = prevSelected.filter((id) => id !== node);
          } else {
            newSelected = [...prevSelected, node];
          }
        } else {
          newSelected = [node];
        }

        // Call setItem here with node.icon.key since you have access to node object:
        if (React.isValidElement(node.icon)) {
          const iconKey = node.icon.key;
          if (iconKey !== null) {
            // Sets the selected room to add stuff
            setItem(iconKey, node.id, node.name);
            if (iconKey === "woning") {
              setSelectedRoom(node);
              //localStorage.setItem('selectedRoomId', node.id);
            }
          }
        }
        return newSelected;
      });
    };

    // Needed to add this to enable drag drop
    // Reason:
    // MUI’s TreeView interferes with native drag-and-drop in Chrome/WebKit browsers
    const dragRef = useCallback((element: HTMLElement | null) => {
      if (element) {
        element.addEventListener("focusin", (e) => {
          e.stopImmediatePropagation();
        });
      }
    }, []);

    // Render the main building tree
    const renderTree = () => {
      const CustomFontTheme = createTheme({
        typography: {
          fontSize: 11,
        },
      });

      const renderTreeItems = () => {
        const arr: kamerItem = treeviewArrayFromOpbouw;

        const renderTree = (nodes: kamerItem): React.ReactNode => {
          const isNodeExpanded = expanded.includes(nodes.id);
          const isExpandable =
            Array.isArray(nodes.children) && nodes.children.length > 0;

          const handleIconClick = (e: React.MouseEvent) => {
            e.stopPropagation();
            if (isExpandable) {
              const newExpanded = isNodeExpanded
                ? expanded.filter((id) => id !== nodes.id)
                : [...expanded, nodes.id];
              setExpanded(newExpanded);
            }
          };

          return (
             <TreeItem
              ref={dragRef}
              key={nodes.id}
              nodeId={nodes.id}
              label={
                <div
                  draggable
                  onDragStart={(e) => onDragStart(e, nodes)}
                  onDragOver={(e) => {
                    e.preventDefault(); // allow drop
                    onDragOver(e);
                  }}
                  onDrop={(e) => onDrop(e, nodes)}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleToggleSelect(nodes, e);
                  }}
                  onContextMenu={(e) => {
                    e.preventDefault();
                    //handleToggleSelect(nodes, e);
                    showMenu(e, nodes);
                  }}
                  onDoubleClick={(e) => {
                    e.preventDefault();
                    showMenu(e, nodes);
                  }}
                  style={{
                    backgroundColor:
                      selectedRoom?.id === nodes.id
                        ? "rgb(112, 111, 111)" //  for selectedRoom
                        : selected.includes(nodes)
                        ? "rgba(87, 87, 87, 1)" // for selected array
                        : "inherit",
                    cursor: "pointer",
                    userSelect: "none",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {nodes.icon && (
                    <span
                      onClick={handleIconClick}
                      style={{
                        marginRight: 4,
                        display: "flex",
                        alignItems: "center",
                        cursor: isExpandable ? "pointer" : "default",
                      }}
                    >
                      {nodes.icon}
                    </span>
                  )}
                  {nodes.name}
                </div>
              }

              
              // Remove default +/- icons and expander space
              collapseIcon={null}
              expandIcon={null}
              endIcon={null}
            >
              {Array.isArray(nodes.children)
                ? nodes.children.map((node) => renderTree(node))
                : null}
            </TreeItem>
          );
        };

        return renderTree(arr);
      };

      const renderTreeComponent = () => (
        <ThemeProvider theme={CustomFontTheme}>
          {renderTreeItems()}
        </ThemeProvider>
      );

      return renderTreeComponent();
    };

    return (
      <>
        <Card className="card_buildingtree" style={{ height: "95vh" }}>
          <CardHeader>
            <Nav>
              <Nav.Item>
                <Nav.Link className="building-nav">{t.woning}</Nav.Link>
              </Nav.Item>
            </Nav>
          </CardHeader>

          {changeName ? renderChangeName() : <></>}
          {duplicateRoom ? renderDuplicateRoom() : <></>}
          {changeIcon ? renderChangeIcon() : <></>}
          {context ? renderContext() : <></>}

          <TreeView
            aria-label="customized"
            expanded={expanded}
            onNodeToggle={handleToggle}
            multiSelect // Enable multi-selection
            sx={{
              overflowX: "hidden",
              "& .MuiTreeItem-iconContainer": {
                display: "none",
              },
            }}
            //defaultCollapseIcon={<span>-</span>}
            //defaultExpandIcon={<span>+</span>}
          >
            {renderTree()}
          </TreeView>
        </Card>
      </>
    );
  },
);

export default BuildingTree;
